import router from '@/router'
import config from '../config'
import { PublicClientApplication } from '@azure/msal-browser';
import { clearAuthSession } from '@/utils/authSession';

const logOutMS = async () => {
    const msalInstance = new PublicClientApplication(config.msalConfig)

    await msalInstance
        .logoutPopup({})
        .catch(error => {
            // eslint-disable-next-line 
            console.error(error);
        });
}

export const logout = async () => {
    const microsoftSession = localStorage.getItem('loginMS') === 'true'

    // Local logout and navigation must never depend on an external popup.
    // Clear the restricted session first so the router guard allows login.
    clearAuthSession()
    await router.replace('/')

    if (microsoftSession) {
        // Microsoft logout is secondary: a blocked/closed popup must not keep
        // the user on an authenticated application route.
        logOutMS().catch(error => {
            // eslint-disable-next-line
            console.error(error)
        })
    }
}

